import React, { useEffect, useState } from 'react';
import { Button, FlexboxGrid, Table } from 'rsuite';

import { useDispatch, useSelector } from 'react-redux';
import { Container } from '~/styles/tabela1';

import {
  buscarNotificacoes,
  marcarNotificacoesLidas as atualizarNotificacoesLidas,
} from '~/store/modulos/notificacao/actions';
import SearchInputTable from '~/components/SearchInputTable';
import { InputDataRange } from '~/components/InputDataRange';
import { TableHeaderTooltip, TablePagination } from '~/components/TablePagination1';
import { CelulaNotifcacao } from '~/components/CelulaNotificacao';
import PageHeader from '../../../components/PageHeader';
import Card from '../../../components/Card';

const { HeaderCell, Column } = Table;

function PedidoRecebido() {
  const [pagina, setPagina] = useState(1);
  const [data, setData] = useState([]);
  const [textodigitado, setTextoDigitado] = useState('');
  const notificacoes = useSelector((state) => state.notificacao.notificacoes);
  const carregando = useSelector((state) => state.notificacao.carregando);
  const pedidosRecebidosNaoLidos = useSelector((state) => state.notificacao.pedidosRecebidosNaoLidos);

  const dispatch = useDispatch();

  useEffect(() => {
    if (notificacoes.quantidade > 0 && notificacoes.lista.length === 0) setPagina(1)
    if (data) {
      dispatch(
        buscarNotificacoes({
          pagina,
          titulo: "Novo pedido",
          mensagem: textodigitado,
          dataInicio: data[0],
          dataFim: data[1],
        })
      );
    }
    if (!data) {
      dispatch(
        buscarNotificacoes({
          pagina,
          titulo: "Novo pedido",
          mensagem: textodigitado,
        })
      );
    }
  }, [pagina, dispatch, textodigitado, data, pedidosRecebidosNaoLidos, notificacoes.quantidade, notificacoes.lista.length]);


  async function marcarNotificacoesLidas() {
    dispatch(atualizarNotificacoesLidas({ pagina, titulo: "Novo pedido" }));
  }

  return (
    <Container>
      <PageHeader
        title="Pedidos Recebidos"
        subtitle="Aqui você pode visualizar todos os pedidos recebidos."
      />
      <Card>
        <FlexboxGrid align="middle" style={{ gap: '10px' }}>
          <SearchInputTable
            estilo={{ width: '300px' }}
            setTextoDigitado={setTextoDigitado} />
          <InputDataRange
            // format="DD/MM/YYYY"
            ranges={[]}
            // placeholder="Data"
            value={data}
            onChange={setData}
          />
          <Button
            // eslint-disable-next-line react/jsx-no-bind
            onClick={marcarNotificacoesLidas}
            size="sm"
          >
            Marcar Todas como lidas
          </Button>
        </FlexboxGrid>
        <FlexboxGrid style={{ width: '100%', paddingTop: '20px' }}>
          <TablePagination
            carregando={carregando}
            dados={notificacoes.lista}
            quantidade={notificacoes.quantidade}
            onChangePage={setPagina}
          >
            <Column resizable width={400}>
              <HeaderCell>
                <TableHeaderTooltip label="Mensagem" tooltip="Mensagem" />
              </HeaderCell>
              <CelulaNotifcacao dataKey="mensagem" />
            </Column>
            <Column resizable width={170}>
              <HeaderCell>
                <TableHeaderTooltip label="Data" tooltip="Data" />
              </HeaderCell>
              <CelulaNotifcacao dataKey="data_formatada" />
            </Column>
          </TablePagination>
        </FlexboxGrid>
      </Card>
    </Container>
  );
}

export default PedidoRecebido
  ;
